import { logger } from '@tecma/logs-fe';
import { Provider } from 'react-redux';
import { WinstonProvider } from 'winston-react';

import { ProviderGraphQl } from './ProviderGraphql';
import { ProviderEnvironment } from './ProviderEnvironment';
import { ProviderI18n } from './ProviderI18n';
import store from '../../store';

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <ProviderEnvironment>
        <ProviderI18n>
          <ProviderGraphQl>
            <WinstonProvider logger={logger}>{children}</WinstonProvider>
          </ProviderGraphQl>
        </ProviderI18n>
      </ProviderEnvironment>
    </Provider>
  );
};
